import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO'; // Import the SEO component
import 'bootstrap/dist/css/bootstrap.min.css';
import spicesVideo from '../assets/Home/0512.mp4';
import cinnamonImage from '../assets/Home/อบเชยป่น-450x450.png';
import cardamomImage from '../assets/Home/cardamoon-1.jpg';
import pepperImage from '../assets/Home/black-pepper.webp';
import clovesImage from '../assets/Home/A1PjxnKmF+L._AC_UF894,1000_QL80_.jpg';
import valuesImage from '../assets/about/Images/3.jpeg';
import spicesOverviewImage from '../assets/about/Images/36.jpeg';
import wholeSpicesImage from '../assets/Home/etsibitsi-premium-pack-of-15-aromatic-whole-garam-masala-spices-original-imag3n9gzrd5c9wq.webp';
import spicePowdersImage from '../assets/Home/Spices.jpg';
import contactBgImage from '../assets/Home/download.jpeg';

function Home() {
    const [selectedItem, setSelectedItem] = useState('Cinnamon');

    const items = {
        'Cinnamon': {
            title: 'Cinnamon - Explore the finest Ceylon Cinnamon',
            description: 'Ceylon Cinnamon is an aromatic spice with medicinal uses for thousands of years, cherished for its sweet, warm taste in global cuisines.',
            image: spicesOverviewImage
        },
        'Whole Spices': {
            title: 'Whole Spices - Authentic flavors of Sri Lanka',
            description: 'Our Whole Spices, including pepper and cloves, are sourced from the best estates, offering robust aromas for every dish.',
            image: wholeSpicesImage
        },
        'Spice Powders': {
            title: 'Spice Powders - Perfect seasoning solutions',
            description: 'Finely ground Spice Powders like cinnamon and turmeric enhance meals with intense, authentic flavors.',
            image: spicePowdersImage
        }
    };
    const [selectedSpiceImage, setSelectedSpiceImage] = useState(null);
    const [isSpiceModalOpen, setIsSpiceModalOpen] = useState(false);

    const openSpiceModal = (image) => {
        setSelectedSpiceImage(image);
        setIsSpiceModalOpen(true);
    };

    const closeSpiceModal = () => {
        setIsSpiceModalOpen(false);
        setSelectedSpiceImage(null);
    };

    const itemKeys = Object.keys(items);

    useEffect(() => {
        const interval = setInterval(() => {
            setSelectedItem((prevItem) => {
                const currentIndex = itemKeys.indexOf(prevItem);
                const nextIndex = (currentIndex + 1) % itemKeys.length;
                return itemKeys[nextIndex];
            });
        }, 2000);

        return () => clearInterval(interval);
    }, [itemKeys]);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://static.elfsight.com/platform/platform.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    // SEO Structured Data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Galle Ceylon Spices International - Home",
        "description": "Welcome to Galle Ceylon Spices International, your source for premium Sri Lankan cinnamon and spices. Explore our organic products and sustainable farming practices from Elpitiya, Sri Lanka.",
        "url": "https://www.galleceylonspices.com/",
        "publisher": {
            "@type": "Organization",
            "name": "Galle Ceylon Spices International (Pvt) Ltd",
            "logo": {
                "@type": "ImageObject",
                "url": "%PUBLIC_URL%/logo.png"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "448/2, Nawadagala",
                "addressLocality": "Elpitiya",
                "postalCode": "80000",
                "addressCountry": "Sri Lanka"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+94-77-929-1829",
                "contactType": "Customer Service",
                "areaServed": "Worldwide",
                "availableLanguage": "English"
            }
        },
        "mainEntity": {
            "@type": "ItemList",
            "itemListElement": [
                {
                    "@type": "Product",
                    "name": "Ceylon Cinnamon",
                    "description": "Premium Ceylon Cinnamon from Galle Ceylon Spices, known for its sweet, warm flavor and medicinal properties.",
                    "image": cinnamonImage
                },
                {
                    "@type": "Product",
                    "name": "Ceylon Cardamom",
                    "description": "High-quality Cardamom pods from Sri Lanka, celebrated for their rich, aromatic profile.",
                    "image": cardamomImage
                },
                {
                    "@type": "Product",
                    "name": "Ceylon Pepper",
                    "description": "Bold and fiery Ceylon Pepper, sourced from the Piper nigrum vine in Sri Lanka.",
                    "image": pepperImage
                },
                {
                    "@type": "Product",
                    "name": "Ceylon Cloves",
                    "description": "Premium Ceylon Cloves, valued in culinary and pharmaceutical industries for their unique flavor.",
                    "image": clovesImage
                }
            ]
        }
    };

    return (
        <>
            <SEO
                title="Galle Ceylon Spices International - Premium Sri Lankan Spices"
                description="Welcome to Galle Ceylon Spices International, your source for premium Sri Lankan cinnamon and spices. Explore our organic products and sustainable farming practices from Elpitiya, Sri Lanka."
                keywords="Galle Ceylon Spices, Sri Lankan spices, organic cinnamon, Ceylon Spice Essence, premium spices, sustainable farming, cinnamon sticks, cardamom, pepper, cloves, Elpitiya Sri Lanka"
                canonicalUrl="https://www.galleceylonspices.com/"
                ogImage="%PUBLIC_URL%/logo.png"
                structuredData={structuredData}
            />
            {/* Video Banner Section */}
            <div className="position-relative" style={{ height: 'clamp(50vh, 100vw, 100vh)', width: '100vw', overflow: 'hidden', marginBottom: '1rem' }}>
                <video
                    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{ zIndex: 0 }}
                >
                    <source src={spicesVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        zIndex: 1
                    }}
                ></div>
                <div
                    className="position-absolute top-50 start-50 translate-middle text-center text-white animate__animated animate__fadeInUp"
                    style={{ zIndex: 2, animationDuration: '1s' }}
                >
                    <h1
                        className="display-4 mb-3 fw-bold"
                        style={{
                            fontFamily: 'Georgia',
                            fontSize: 'clamp(1.8rem, 5vw, 3rem)',
                            textShadow: '2px 2px 10px rgba(0, 0, 0, 0.7)'
                        }}
                    >
                        Welcome to Galle Ceylon Spices
                    </h1>
                    <p
                        className="lead"
                        style={{
                            fontFamily: 'Georgia',
                            fontSize: 'clamp(1rem, 3vw, 1.5rem)',
                            textShadow: '1px 1px 5px rgba(0, 0, 0, 0.7)'
                        }}
                    >
                        Discover the authentic flavors of Ceylon spices.
                    </p>
                </div>
            </div>

            {/* Company Section */}
            <div className="container my-4" style={{ paddingTop: '20px' }}>
                <section
                    className="animate__animated animate__fadeIn"
                    style={{
                        animationDuration: '1s',
                        marginTop: 'clamp(1rem, 5vw, 2rem)',
                    }}
                >
                    <div className="text-center">
                        <h2
                            className="mb-3 position-relative text-center"
                            style={{
                                fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                                color: '#355E3B',
                                fontFamily: 'Georgia',
                                fontWeight: 'bold',
                            }}
                        >
                            Galle Ceylon Spices International (Pvt) Ltd
                            <span
                                style={{
                                    position: 'absolute',
                                    bottom: '-8px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '80px',
                                    height: '2px',
                                    backgroundColor: '#C19A6B',
                                    borderRadius: '2px',
                                }}
                            />
                        </h2>
                        <p
                            className="text-muted mx-auto"
                            style={{
                                fontFamily: 'Georgia',
                                fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                lineHeight: '1.8',
                                maxWidth: '700px',
                                color: '#355E3B',
                            }}
                        >
                            The exotic spice trade has been part of the fabric of Ceylon for centuries, even before the Portuguese traders and European conquistadors arrived. Galle Ceylon Spices International (Pvt) Ltd, established in 1990, continues this rich legacy, specializing in the finest Ceylon cinnamon, pepper, cloves, and more. Based in Elpitiya, our company brings the authentic flavors of Sri Lanka to global markets, renowned for their unique aroma and flavor, all under the geographical indication of Ceylon Spices.
                        </p>
                    </div>
                </section>
            </div>

            {/* Spices Section */}
            <div className="container my-4" style={{ paddingTop: '20px' }}>
                <section className="animate__animated animate__fadeIn" style={{ animationDuration: '1s' }}>
                    <div className="row g-3 justify-content-center">
                        <div className="col-12 col-sm-6 col-md-3 text-center animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
                            <img
                                src={cinnamonImage}
                                alt="Galle Ceylon Spices Cinnamon sticks"
                                className="img-fluid rounded-3 shadow-lg"
                                style={{
                                    maxHeight: 'clamp(400px, 40vw, 400px)',
                                    objectFit: 'cover',
                                    width: '100%',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                    cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(193, 154, 107, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                }}
                                onClick={() => openSpiceModal({ src: cinnamonImage, alt: 'Galle Ceylon Spices Cinnamon sticks' })}
                            />
                            <h5
                                className="mt-3 text-dark fw-bold"
                                style={{
                                    color: '#355E3B',
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                }}
                            >
                                Galle Ceylon Cinnamon
                            </h5>
                            <p
                                className="text-muted"
                                style={{
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)',
                                    lineHeight: '1.5',
                                    color: '#355E3B',
                                }}
                            >
                                Galle Ceylon Spices International (Pvt) Ltd brings you the finest Ceylon Cinnamon, a fragrant spice with a history of medicinal use spanning millennia. Renowned for its sweet, warm flavor, it’s a cherished ingredient in global cuisines, adding depth to countless recipes.
                            </p>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 text-center animate__animated animate__fadeInUp" style={{ animationDelay: '0.4s', animationDuration: '0.8s' }}>
                            <img
                                src={cardamomImage}
                                alt="Galle Ceylon Spices Cardamom pods"
                                className="img-fluid rounded-3 shadow-lg"
                                style={{
                                    maxHeight: 'clamp(300px, 40vw, 300px)',
                                    objectFit: 'cover',
                                    width: '100%',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                    cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(193, 154, 107, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                }}
                                onClick={() => openSpiceModal({ src: cardamomImage, alt: 'Galle Ceylon Spices Cardamom pods' })}
                            />
                            <h5
                                className="mt-3 text-dark fw-bold"
                                style={{
                                    color: '#355E3B',
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                }}
                            >
                                Galle Ceylon Cardamom
                            </h5>
                            <p
                                className="text-muted"
                                style={{
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)',
                                    lineHeight: '1.5',
                                    color: '#355E3B',
                                }}
                            >
                                Sourced from the lush highlands of Sri Lanka by Galle Ceylon Spices International (Pvt) Ltd, our Cardamom, known as the "Queen of Spices," has been a prized treasure since ancient times. Once used as a divine offering, it’s celebrated for its rich, aromatic profile.
                            </p>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 text-center animate__animated animate__fadeInUp" style={{ animationDelay: '0.6s', animationDuration: '0.8s' }}>
                            <img
                                src={pepperImage}
                                alt="Galle Ceylon Spices Pepper berries"
                                className="img-fluid rounded-3 shadow-lg"
                                style={{
                                    maxHeight: 'clamp(400px, 40vw, 400px)',
                                    objectFit: 'cover',
                                    width: '100%',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                    cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(193, 154, 107, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                }}
                                onClick={() => openSpiceModal({ src: pepperImage, alt: 'Galle Ceylon Spices Pepper berries' })}
                            />
                            <h5
                                className="mt-3 text-dark fw-bold"
                                style={{
                                    color: '#355E3B',
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                }}
                            >
                                Galle Ceylon Pepper
                            </h5>
                            <p
                                className="text-muted"
                                style={{
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)',
                                    lineHeight: '1.5',
                                    color: '#355E3B',
                                }}
                            >
                                Galle Ceylon Spices International (Pvt) Ltd proudly cultivates Ceylon Pepper, the "King of Spices," thriving in Sri Lanka’s wilderness. Harvested from the Piper nigrum vine, this globally cherished spice adds a bold, fiery essence to dishes worldwide.
                            </p>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 text-center animate__animated animate__fadeInUp" style={{ animationDelay: '0.8s', animationDuration: '0.8s' }}>
                            <img
                                src={clovesImage}
                                alt="Galle Ceylon Spices Cloves buds"
                                className="img-fluid rounded-3 shadow-lg"
                                style={{
                                    maxHeight: 'clamp(400px, 40vw, 400px)',
                                    objectFit: 'cover',
                                    width: '100%',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                    cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(193, 154, 107, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                }}
                                onClick={() => openSpiceModal({ src: clovesImage, alt: 'Galle Ceylon Spices Cloves buds' })}
                            />
                            <h5
                                className="mt-3 text-dark fw-bold"
                                style={{
                                    color: '#355E3B',
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                }}
                            >
                                Galle Ceylon Cloves
                            </h5>
                            <p
                                className="text-muted"
                                style={{
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)',
                                    lineHeight: '1.5',
                                    color: '#355E3B',
                                }}
                            >
                                Galle Ceylon Spices International (Pvt) Ltd offers premium Ceylon Cloves, unopened buds from the Myrtaceae tree. Valued in culinary, pharmaceutical, and perfume industries, they’re also used as natural painkillers in dentistry across various cultures.
                            </p>
                        </div>
                    </div>
                    <div className="text-center mt-4">
                        <Link to="/products" style={{ textDecoration: 'none' }}>
                            <button
                                className="btn rounded-3"
                                style={{
                                    backgroundColor: '#C19A6B',
                                    color: '#FFFFFF',
                                    padding: 'clamp(8px, 2vw, 10px) clamp(15px, 3vw, 20px)',
                                    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                    fontFamily: 'Georgia',
                                    transition: 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out',
                                    border: 'none',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#A67B4D';
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#C19A6B';
                                    e.currentTarget.style.transform = 'scale(1)';
                                }}
                            >
                                View More
                            </button>
                        </Link>
                    </div>

                    {/* Modal for Full-Screen Spice Image */}
                    {isSpiceModalOpen && (
                        <div
                            className="modal animate__animated animate__fadeIn"
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                background: 'rgba(0, 0, 0, 0.8)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 1000,
                                animationDuration: '0.5s',
                            }}
                            onClick={closeSpiceModal}
                        >
                            <div
                                style={{
                                    position: 'relative',
                                    maxWidth: '80%',
                                    maxHeight: '90vh',
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedSpiceImage.src}
                                    alt={selectedSpiceImage.alt}
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '90vh',
                                        borderRadius: '8px',
                                        boxShadow: '0 12px 30px rgba(193, 154, 107, 0.6)',
                                        objectFit: 'contain',
                                    }}
                                />
                                <button
                                    onClick={closeSpiceModal}
                                    style={{
                                        position: 'absolute',
                                        top: '-35px',
                                        right: '-35px',
                                        backgroundColor: '#C19A6B',
                                        border: 'none',
                                        color: '#FFFFFF',
                                        width: 'clamp(30px, 5vw, 40px)',
                                        height: 'clamp(30px, 5vw, 40px)',
                                        borderRadius: '50%',
                                        fontSize: 'clamp(1.2rem, 2.5vw, 1.5rem)',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#A67B4D';
                                        e.currentTarget.style.transform = 'scale(1.1)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#C19A6B';
                                        e.currentTarget.style.transform = 'scale(1)';
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                        </div>
                    )}
                </section>
            </div>

            {/* Values Section */}
            <div className="container my-4" style={{ paddingTop: 'clamp(2rem, 5vw, 4rem)', }}>
                <section className="animate__animated animate__fadeIn" style={{ animationDuration: '1s' }}>
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
                            <h2
                                className="mb-3 position-relative text-center"
                                style={{
                                    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                                    color: '#355E3B',
                                    fontFamily: 'Georgia',
                                    fontWeight: 'bold',
                                }}
                            >
                                Our Values
                                <span
                                    style={{
                                        position: 'absolute',
                                        bottom: '-8px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        width: '80px',
                                        height: '2px',
                                        backgroundColor: '#C19A6B',
                                        borderRadius: '2px',
                                    }}
                                />
                                <style>
                                    {`
            @media (min-width: 577px) {
                .mb-3.position-relative {
                    text-align: left;
                }
                .mb-3.position-relative span {
                    left: 0;
                    transform: none;
                }
            }
        `}
                                </style>
                            </h2>
                            <p
                                className="text-muted"
                                style={{
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                    lineHeight: '1.8',
                                    color: '#355E3B',
                                }}
                            >
                                At Galle Ceylon Spices International (Pvt) Ltd, we are committed to delivering the highest quality spices sourced sustainably from the rich lands of Sri Lanka. Our dedication to excellence ensures that every product reflects the authentic flavors and traditions of Ceylon.
                            </p>
                            <p
                                className="text-muted mt-3"
                                style={{
                                    fontFamily: 'Georgia',
                                    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                    lineHeight: '1.8',
                                    color: '#355E3B',
                                }}
                            >
                                We prioritize environmental stewardship and support local farmers, fostering a legacy of trust and innovation. Our values drive us to provide exceptional service and products that enhance culinary experiences worldwide.
                            </p>
                            <style>
                                {`
        @media (max-width: 576px) {
            .text-muted {
                text-align: center;
            }
        }
    `}
                            </style>
                        </div>
                        <div className="col-12 col-md-6 d-flex align-items-center animate__animated animate__fadeInUp" style={{ animationDelay: '0.4s', animationDuration: '0.8s' }}>
                            <img
                                src={valuesImage}
                                alt="Galle Ceylon Spices values representation"
                                className="img-fluid rounded-3 shadow-lg"
                                style={{
                                    width: '100%',
                                    height: 'clamp(300px, 40vw, 400px)',
                                    objectFit: 'cover',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(193, 154, 107, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                }}
                            />
                        </div>
                    </div>
                </section>
            </div>

            {/* Spice Offerings Section */}
            <div className="container my-4" style={{ paddingTop: 'clamp(1rem, 5vw, 2rem)' }}>
                <section className="animate__animated animate__fadeIn" style={{ animationDuration: '1s' }}>
                    <div className="row align-items-center">
                        <div className="col-12 col-md-6 animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s', animationDuration: '0.8s' }}>
                            <img
                                src={items[selectedItem].image}
                                alt={`${selectedItem} overview`}
                                className="img-fluid rounded-3 shadow-lg"
                                style={{
                                    width: '100%',
                                    height: 'clamp(450px, 40vw, 400px)',
                                    objectFit: 'cover',
                                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 20px rgba(193, 154, 107, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                                }}
                            />
                        </div>
                        <div className="col-12 col-md-6 animate__animated animate__fadeInUp" style={{ animationDelay: '0.4s', animationDuration: '0.8s' }}>
                            <div className="mb-3">
                                <div
                                    className={`p-2 mb-2 rounded-3 ${selectedItem === 'Cinnamon' ? 'custom-selected' : 'bg-light'}`}
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease-in-out, border 0.3s ease-in-out',
                                        border: selectedItem === 'Cinnamon' ? '2px solid #C19A6B' : '1px solid transparent',
                                        backgroundColor: selectedItem === 'Cinnamon' ? '#C19A6B' : '',
                                    }}
                                    onClick={() => setSelectedItem('Cinnamon')}
                                    onMouseEnter={(e) => {
                                        if (selectedItem !== 'Cinnamon') e.currentTarget.style.border = '2px solid #C19A6B';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (selectedItem !== 'Cinnamon') e.currentTarget.style.border = '1px solid transparent';
                                    }}
                                >
                                    <h5
                                        className="mb-2"
                                        style={{
                                            fontFamily: 'Georgia',
                                            color: selectedItem === 'Cinnamon' ? '#FFFFFF' : '#355E3B',
                                            fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                        }}
                                    >
                                        Cinnamon - Explore the finest Ceylon Cinnamon
                                    </h5>
                                    <p
                                        className="mb-0"
                                        style={{
                                            fontFamily: 'Georgia',
                                            fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)',
                                            color: selectedItem === 'Cinnamon' ? '#FFFFFF' : '#355E3B',
                                        }}
                                    >
                                        Galle Ceylon Cinnamon is an aromatic spice with medicinal uses for thousands of years, cherished for its sweet, warm taste in global cuisines.
                                    </p>
                                </div>
                                <div
                                    className={`p-2 mb-2 rounded-3 ${selectedItem === 'Whole Spices' ? 'custom-selected' : 'bg-light'}`}
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease-in-out, border 0.3s ease-in-out',
                                        border: selectedItem === 'Whole Spices' ? '2px solid #C19A6B' : '1px solid transparent',
                                        backgroundColor: selectedItem === 'Whole Spices' ? '#C19A6B' : '',
                                    }}
                                    onClick={() => setSelectedItem('Whole Spices')}
                                    onMouseEnter={(e) => {
                                        if (selectedItem !== 'Whole Spices') e.currentTarget.style.border = '2px solid #C19A6B';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (selectedItem !== 'Whole Spices') e.currentTarget.style.border = '1px solid transparent';
                                    }}
                                >
                                    <h5
                                        className="mb-2"
                                        style={{
                                            fontFamily: 'Georgia',
                                            color: selectedItem === 'Whole Spices' ? '#FFFFFF' : '#355E3B',
                                            fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                        }}
                                    >
                                        Whole Spices - Authentic flavors of Sri Lanka
                                    </h5>
                                    <p
                                        className="mb-0"
                                        style={{
                                            fontFamily: 'Georgia',
                                            fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)',
                                            color: selectedItem === 'Whole Spices' ? '#FFFFFF' : '#355E3B',
                                        }}
                                    >
                                        Our Whole Spices, including pepper and cloves, are sourced from the best estates, offering robust aromas for every dish.
                                    </p>
                                </div>
                                <div
                                    className={`p-2 mb-2 rounded-3 ${selectedItem === 'Spice Powders' ? 'custom-selected' : 'bg-light'}`}
                                    style={{
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease-in-out, border 0.3s ease-in-out',
                                        border: selectedItem === 'Spice Powders' ? '2px solid #C19A6B' : '1px solid transparent',
                                        backgroundColor: selectedItem === 'Spice Powders' ? '#C19A6B' : '',
                                    }}
                                    onClick={() => setSelectedItem('Spice Powders')}
                                    onMouseEnter={(e) => {
                                        if (selectedItem !== 'Spice Powders') e.currentTarget.style.border = '2px solid #C19A6B';
                                    }}
                                    onMouseLeave={(e) => {
                                        if (selectedItem !== 'Spice Powders') e.currentTarget.style.border = '1px solid transparent';
                                    }}
                                >
                                    <h5
                                        className="mb-2"
                                        style={{
                                            fontFamily: 'Georgia',
                                            color: selectedItem === 'Spice Powders' ? '#FFFFFF' : '#355E3B',
                                            fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                                        }}
                                    >
                                        Spice Powders - Perfect seasoning solutions
                                    </h5>
                                    <p
                                        className="mb-0"
                                        style={{
                                            fontFamily: 'Georgia',
                                            fontSize: 'clamp(0.8rem, 1.5vw, 0.9rem)',
                                            color: selectedItem === 'Spice Powders' ? '#FFFFFF' : '#355E3B',
                                        }}
                                    >
                                        Finely ground Spice Powders like cinnamon and turmeric enhance meals with intense, authentic flavors.
                                    </p>
                                </div>
                                <style>
                                    {`
            @media (max-width: 576px) {
                .mb-3 {
                    margin-top: 1rem !important;
                    padding-top: 1rem !important;
                }
            }
        `}
                                </style>
                            </div>
                            <div className="text-center mt-3">
                                <Link to="/shop" style={{ textDecoration: 'none' }}>
                                    <button
                                        className="btn rounded-3"
                                        style={{
                                            backgroundColor: '#C19A6B',
                                            color: '#FFFFFF',
                                            padding: 'clamp(8px, 2vw, 10px) clamp(15px, 3vw, 20px)',
                                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                            fontFamily: 'Georgia',
                                            transition: 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out',
                                            border: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#A67B4D';
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = '#C19A6B';
                                            e.currentTarget.style.transform = 'scale(1)';
                                        }}
                                    >
                                        Shop Now
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Google Reviews Section */}
            <div className="container my-4" style={{ paddingTop: '30px' }}>
                <section
                    className="py-4 rounded-3 shadow-lg animate__animated animate__fadeIn"
                    style={{
                        animationDuration: '1s',
                        backgroundColor: 'rgba(193, 154, 107, 0.1)',
                    }}
                >
                    <div className="text-center">
                        <h2
                            className="mb-3 position-relative text-center"
                            style={{
                                fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                                color: '#355E3B',
                                fontFamily: 'Georgia',
                                fontWeight: 'bold',
                            }}
                        >
                            What Our Customers Say
                            <span
                                style={{
                                    position: 'absolute',
                                    bottom: '-8px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '80px',
                                    height: '2px',
                                    backgroundColor: '#C19A6B',
                                    borderRadius: '2px',
                                }}
                            />
                        </h2>
                        <p
                            className="text-muted mx-auto mb-4"
                            style={{
                                fontFamily: 'Georgia',
                                fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                                lineHeight: '1.8',
                                maxWidth: '700px',
                                color: '#355E3B',
                            }}
                        >
                            Hear from our satisfied customers about their experiences with Galle Ceylon Spices. Your trust means the world to us!
                        </p>
                    </div>
                    <div className="elfsight-app-94d20460-8b9b-4e03-9759-8c076c10d647" data-elfsight-app-lazy></div>
                </section>
            </div>

            {/* Get In Touch Section */}
            <div
                className="position-relative py-4 d-flex align-items-center justify-content-center"
                style={{
                    backgroundImage: `url(${contactBgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: 'clamp(300px, 50vw, 400px)',
                    width: '100%',
                    marginBottom: 'clamp(1rem, 5vw, 2rem)',
                }}
            >
                <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        zIndex: 1
                    }}
                ></div>
                <div className="container position-relative text-center text-white animate__animated animate__fadeInUp" style={{ zIndex: 2, animationDuration: '1s' }}>
                    <h2
                        className="mb-3 fw-bold"
                        style={{
                            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
                            letterSpacing: '1px',
                            fontFamily: 'Georgia',
                            textShadow: '2px 2px 10px rgba(0, 0, 0, 0.7)',
                        }}
                    >
                        Get In Touch
                    </h2>
                    <p
                        className="mx-auto mb-4"
                        style={{
                            fontFamily: 'Georgia',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            lineHeight: '1.8',
                            maxWidth: '700px',
                            textShadow: '1px 1px 5px rgba(0, 0, 0, 0.7)',
                        }}
                    >
                        Have questions or want to learn more about our premium Ceylon spices? Reach out to us today—we’d love to hear from you!
                    </p>
                    <Link
                        to="/contact"
                        className="btn rounded-3"
                        style={{
                            backgroundColor: '#C19A6B',
                            color: '#FFFFFF',
                            padding: 'clamp(8px, 2vw, 10px) clamp(15px, 3vw, 20px)',
                            fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                            fontFamily: 'Georgia',
                            transition: 'background-color 0.3s ease-in-out, transform 0.3s ease-in-out',
                            border: 'none',
                            textDecoration: 'none',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#A67B4D';
                            e.currentTarget.style.transform = 'scale(1.05)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#C19A6B';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        Contact Us
                    </Link>
                </div>
            </div>
        </>
    );
}

export default Home;